import Player from "@/components/LottiePlayer"

export default function Note({ children, color, type }) {
  const colorClass = color === 'orange'
  ? '!bg-[#fb923c] border-[#fb923c]'
  : color === 'white'
  ? 'bg-white border-[#e5e7eb]'
  : 'bg-[#f2f3f5] border-[#f2f3f5]';
  const textColor = color === 'orange' ? 'text-white' : 'text-secgray';
  
  const icons = {
    casestudy: '/assets/icons/presentation-2.json',
    puzzle: '/assets/icons/puzzle.json',
    'star-white': '/assets/icons/favorite-white.json'
  };

  return (
    <section className={`note ${colorClass} shadow-md border-2`}>
      <div className="flex items-center gap-3">
        {icons[type] && (
          <div className="mt-1 flex h-14 w-14 flex-none items-center justify-center rounded-lg">
            <Player autoplay loop src={icons[type]} className="p-1" />
          </div>
        )}
        <div className={textColor}>{children}</div>
      </div>
    </section>
  );
}